module.exports = __webpack_public_path__ + "static/media/stripe.ce62e008.png";